exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.CoverImage__carouselImageClassName___2OqIE {\n  vertical-align: top;\n  margin-top: -1px;\n  border-radius: 10px; }\n\ndiv.CoverImage__carouselImageClassName___2OqIE {\n  height: 220px; }\n\n.CoverImage__image___3-7GP {\n  height: 220px;\n  border-radius: 10px; }\n\n@media (max-width: 576px) {\n  .CoverImage__image___3-7GP,\n  div.CoverImage__carouselImageClassName___2OqIE {\n    height: 130px; } }\n", ""]);

// exports
exports.locals = {
	"carouselImageClassName": "CoverImage__carouselImageClassName___2OqIE",
	"image": "CoverImage__image___3-7GP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/CoverImage/CoverImage.scss
// module id = 3915
// module chunks = 6